import { PersistedQueryParamsContext, usePersistedQueryParamsContextValue } from "hooks/usePersistedQueryParams";

export function PersistedQueryParamsContextProvider({ children }: $TSFixMe) {
    const value = usePersistedQueryParamsContextValue();

    return <PersistedQueryParamsContext.Provider value={value}>{children}</PersistedQueryParamsContext.Provider>;
}

export default PersistedQueryParamsContextProvider;
